<template>
    <div class="login-bg">
        <div class="login-box">
            <div class="login-box-left">
                <img :src="loginLog" alt="">
                <h2>重置密码</h2>
                <template v-if="isSuccess">
                    <div class="login-form">
                        <div class="login-center">
                            <Icon type="ios-checkmark-circle" size="120" color="#19be6b" />
                            <p>重置成功</p>
                        </div>
                        <p class="register" style="width: 100%;">
                            <Button class="login-btn" type="primary" @click="backLogin">返回登录</Button>
                        </p>
                    </div>
                </template>
                <template v-else>
                    <div class="login-form">
                        <div class="mobilephone">
                            <div class="input-box">
                                <input type="text" placeholder="请输入账号(仅为数字和英文字母组合)" v-model.trim="account"
                                    @blur="checkAccount">
                                <span class="icon icon-user-01"></span>
                                <span class="err-tips" v-if="checkAccountCtrl === 'error'">{{ checkAccountMes }}</span>
                                <Icon class="tips-icon" v-if="checkAccountCtrl === 'error'" size="22" color="red"
                                    type="ios-close-circle-outline" />
                                <Icon class="tips-icon" v-if="checkAccountCtrl === 'success'" size="22" color="green"
                                    type="ios-checkmark-circle-outline" />
                            </div>
                            <div class="input-box">
                                <input type="password" placeholder="请输入密码(数字、字母或者两者组合)" v-model="password"
                                    @blur="checkPassword">
                                <span class="icon icon-password-01"></span>
                                <span class="err-tips" v-if="checkPasswordCtrl === 'error'">{{ checkPasswordMes }}</span>
                                <Icon class="tips-icon" v-if="checkPasswordCtrl === 'error'" size="22" color="red"
                                    type="ios-close-circle-outline" />
                                <Icon class="tips-icon" v-if="checkPasswordCtrl === 'success'" size="22" color="green"
                                    type="ios-checkmark-circle-outline" />
                            </div>
                            <div class="input-box">
                                <input type="password" placeholder="请输入再次密码(数字、字母或者两者组合)" v-model="rePassword"
                                    @blur="checkRePassword">
                                <span class="icon icon-password-01"></span>
                                <span class="err-tips" v-if="checkRePasswordCtrl === 'error'">{{ checkRePasswordMes
                                }}</span>
                                <Icon class="tips-icon" v-if="checkRePasswordCtrl === 'error'" size="22" color="red"
                                    type="ios-close-circle-outline" />
                                <Icon class="tips-icon" v-if="checkRePasswordCtrl === 'success'" size="22" color="green"
                                    type="ios-checkmark-circle-outline" />
                            </div>
                            <div class="input-box">
                                <input type="text" placeholder="请输入手机号" v-model.trim="mobile" @blur="checkMobile">
                                <span class="icon icon-phone-01"></span>
                                <span class="err-tips" v-if="checkMobileCtrl == 'error'">{{ checkMobileMes }}</span>
                                <Icon class="tips-icon" v-if="checkMobileCtrl == 'error'" size="22" color="red"
                                    type="ios-close-circle-outline" />
                                <Icon class="tips-icon" v-if="checkMobileCtrl == 'success'" size="22" color="green"
                                    type="ios-checkmark-circle-outline" />
                            </div>
                            <div class="input-box" style="margin-bottom: 0;">
                                <input type="text" placeholder="请输入验证码" v-model.trim="smCode">
                                <span class="icon icon-password-01"></span>
                                <span class="text send-verification-code" @click="sendCode()" v-if="!sendCodeCtrl"
                                    id="TencentCaptcha">发送验证码</span>
                                <span class="text resend" v-if="sendCodeCtrl">重新发送（{{ second }}S）</span>
                            </div>

                        </div>
                        <Button class="login-btn" type="primary" v-if="isSubmit" @click="handleSubmit()">{{ $t('Confirm') }}</Button>
                        <Button class="login-btn disabled-btn" v-if="!isSubmit">{{ $t('Confirm') }}</Button>
                        <p class="register" style="bottom: -3%;width: 100%;">已有账号！<a href="/#/login">立即登录</a></p>
                    </div>
                </template>
            </div>
            <div class="login-box-right"></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isSuccess: false,
            loginLog: require('../../assets/images/login-logo.png'),
            rightBg: require('../../assets/images/cust-01.png'),
            mobile: '',
            smCode: '',
            account: '',
            password: '',
            rePassword: '',
            sendCodeCtrl: false,
            checkMobileCtrl: '',
            checkMobileMes: '',
            checkAccountCtrl: '',
            checkAccountMes: '',
            second: 59,
            checkPasswordCtrl: '',
            checkPasswordMes: '',
            checkRePasswordCtrl: '',
            checkRePasswordMes: '',

            isSubmit: false
        }
    },
    props: [''],
    methods: {
        backLogin() {
            this.isSuccess = false;
            this.$router.push({
                name: "login"
            });
        },
        //检查手机号是否注册或者已绑定
        checkMobile() {
            if (this.mobile.trim() == '') {
                this.checkMobileCtrl = 'error';
                this.checkMobileMes = '手机号不能为空';
                return false;
            }
            if (!(/^1[3456789]\d{9}$/.test(this.mobile))) {
                this.checkMobileCtrl = 'error';
                this.checkMobileMes = '手机号码有误，请重填';
                return false;
            }
            let url = '/base/account/check-mobile?mobile=' + this.mobile;
            this.$get(url).then(res => {
                if (res.code == 0 && res.data) {
                    this.checkMobileCtrl = 'success';
                } else {
                    this.checkMobileCtrl = 'error';
                    this.checkMobileMes = '手机未注册';
                }
            })
        },
        //检查账号是否存在
        checkAccount() {
            if (this.account.trim() == '') {
                this.checkAccountCtrl = 'error';
                this.checkAccountMes = '账号不能为空';
                return false;
            }
            // if (/^[^\d]*$|^[^a-zA-Z]*$|[^\da-zA-Z]/.test(this.account)) {
            //     this.checkAccountCtrl = 'error';
            //     this.checkAccountMes = '账号仅使用数字和字母组合';
            //     return false;
            // }
            if (this.account.length < 6 || this.account.length > 32) {
                this.checkAccountCtrl = 'error';
                this.checkAccountMes = '账号不能少于6个字符且不能超过32个字符';
                return false;
            }
            let url = '/base/account/check?accountName=' + this.account;
            this.$get(url).then(res => {
                if (res.code == 0 && res.data) {
                    this.checkAccountCtrl = 'success';
                } else {
                    this.checkAccountCtrl = 'error';
                    this.checkAccountMes = '账号未注册';
                }
            })
        },
        //检查密码规则
        checkPassword() {
            if (this.password.trim() == '') {
                this.checkPasswordMes = '请输入密码';
                this.checkPasswordCtrl = 'error';
            } else if (this.password.length < 6 || this.password.length > 32) {
                this.checkPasswordMes = '密码不能少于6个字符且不能超过32个字符';
                this.checkPasswordCtrl = 'error';
            } else if (/[\`\~\!\！\、\。\，\@\#\$\%\^\&\*\+\\\]\}\{\'\;\:\"\/\.\,\>\<\s\|\=\-\?]/g.test(this.password) || /[\u4e00-\u9fa5]/g.test(this.password)) {
                this.checkPasswordMes = '密码格式为数字、字母或者两者组合';
                this.checkPasswordCtrl = 'error';
            } else {
                this.checkPasswordCtrl = 'success';
            }
        },



        checkRePassword() {
            if (this.rePassword.trim() == '') {
                this.checkRePasswordMes = '请输入密码';
                this.checkRePasswordCtrl = 'error';
            } else if (this.rePassword.length < 6 || this.rePassword.length > 32) {
                this.checkRePasswordMes = '密码不能少于6个字符且不能超过32个字符';
                this.checkRePasswordCtrl = 'error';
            } else if (/[\`\~\!\！\、\。\，\@\#\$\%\^\&\*\+\\\]\}\{\'\;\:\"\/\.\,\>\<\s\|\=\-\?]/g.test(this.password) || /[\u4e00-\u9fa5]/g.test(this.password)) {
                this.checkRePasswordMes = '密码格式为数字、字母或者两者组合';
                this.checkRePasswordCtrl = 'error';
            } else if (this.password !== this.rePassword) {
                this.checkRePasswordMes = '两次输入的密码不一致';
                this.checkRePasswordCtrl = 'error';
            } else {
                this.checkRePasswordCtrl = 'success';
            }



        },
        //发送验证码
        sendCode() {
            if (this.checkAccountCtrl === 'error') {
                return false;
            }
            let _this = this;
            let url = '/base/verify/getImageVerifyConfig';
            this.$get(url).then(res => {
                //先验证图形码
                let captcha = new TencentCaptcha(res.data.appId + '', function (res) {
                    _this.getSmCode(res.ticket, res.randstr);
                });
                captcha.show();
                document.getElementById('t_mask').style.background = '#fff';
            })
        },
        getSmCode(ticket, randstr) {
            // 假装获取验证码
            let url = '/base/sms/getSmsCode?mobile=' + this.mobile + '&ticket=' + ticket + '&randStr=' + randstr;
            this.$get(url).then(res => {
                if (res.code == 0) {
                    this.sendCodeCtrl = true;
                    this.second = 59;
                    let timeId = null;
                    timeId = setInterval(() => {
                        this.second--;
                        if (this.second < 0) {
                            clearInterval(timeId);
                            this.sendCodeCtrl = false;
                        }
                    }, 1000)
                } else {
                    this.$Message.error(res.message);
                }
            })
        },
        //注册
        handleSubmit() {
            if (this.checkMobileCtrl == 'error' || this.checkAccountCtrl == 'error' || this.checkPasswordCtrl == 'error'
                || this.checkRePasswordCtrl == 'error') {
                return false;
            }
            let url = '/base/account/resetPwd';
            let ajaxData = {
                clientId: 'service_customer',
                mobile: this.mobile,
                smsCode: this.smCode,
                accountName: this.account,
                newPwd1: this.password,
                newPwd2: this.rePassword,
            };
            this.$post(url, ajaxData).then(res => {
                if (res.code == 0) {
                    this.$Message.success('重置密码成功！');
                    let _this = this;
                    _this.isSuccess = true;
                } else {
                    this.$Message.error(res.message);
                }
            })
        },
        // 检查输入框是否填写完整及正确
        watchIsSubmit() {
            let requiredArr = ['mobile', 'smCode', 'account', 'password'];
            for (let i = 0; i < requiredArr.length; i++) {
                if (this[requiredArr[i]] == '') {
                    return false;
                }
            }
            return true;
        }
    },
    created() {

    },
    beforeMount() {

    },
    mounted() {

    },
    updated() {

    },
    components: {},
    watch: {
        mobile(val) {
            if (val) {
                this.isSubmit = this.watchIsSubmit();
            }
        },
        smCode(val) {
            if (val) {
                this.isSubmit = this.watchIsSubmit();
            }
        },
        account(val) {
            if (val) {
                this.isSubmit = this.watchIsSubmit();
            }
        },
        password(val) {
            if (val) {
                this.isSubmit = this.watchIsSubmit();
            }
        }
    }
}
</script>
<style lang="sass" scoped>
 @import "../login/login.scss"
 </style>
 
 


// WEBPACK FOOTER //
// src/view/resetPassword/resetPassword.vue